// @flow
/**
 * UnsupportedOperationException
 */
class UnsupportedOperationException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UnsupportedOperationException";
  }
}

export default UnsupportedOperationException;
